var path = 'components/legend-config-button.tpl.html';
var html = " <md-button ng-disabled=disabled class=\"md-raised md-primary\" ng-click=openEditMode($event)> <ng-md-icon icon=toc></ng-md-icon> <span translate>legend.settings</span> </md-button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/legend-config-button.tpl.html
// module id = 1405
// module chunks = 1